import { Component, OnInit } from "@angular/core";
import { ApiService } from "../../shared/services/api.service";
import { Urls } from "../../utils/urls";
import { ToastrService } from "ngx-toastr";
import { CommonDataService } from "@shared/services/common-data.service";
import { environment } from '../../../environments/environment.prod'
import {
  No_branches_are_available_for_Selected_State,
  No_data_found_for_the_selected_city,
  Something_went_wrong
} from "@root/app.constant"
import { RedirectionService } from "@root/shared/services/redirection.service";

@Component({
  selector: "app-contact-us",
  templateUrl: "./contact-us.component.html",
  styleUrls: ["./contact-us.component.scss"],
})
export class ContactUsComponent implements OnInit {
  
  zoom = 14;
  userData = {
    state: "",
    city: "",
  };
  contactData = {
    helpLines: [
      {
        key: "Toll-free Number",
        value: "1800-266-9603",
      },
      {
        key: "Board Line Number",
        value: "022 69153500",
      },
      {
        key: "Working Hours",
        value: "Monday to Saturday – 9:00 AM to 6:00 PM",
      },
    ],
    mailUs: [
      {
        mailId: "For investors: mfassist@itiorg.com",
      },
      {
        mailId: "For distributors: mypartner@itiorg.com",
      },
    ],
    grievance: {
      name: "Ms. Nimisha Keny",
      phone: "022 69153500",
      email: "iro@itiorg.com",
    },
  };
  stateList: any[] = [];

  cityList: any[] = [];

  subContacts: any = [];

  defaultCoordinate = {
    "latitude": 19.0056944,
    "longitude": 72.8281456
  }
  center = { lat: 19.0056944, lng: 72.8281456 };  // Example coordinates (San Francisco)
  constructor(public apiService: ApiService,
    private toastr: ToastrService,
    private commonDataService: CommonDataService, private redirectionService : RedirectionService) { }

  ngOnInit() {
    this.getStates();
    this.apiService.loadGoogleMapsApi().then(() => {
      console.log('Google Maps API loaded successfully.');
      this.initMap();
    }).catch(error => {
      console.error('Error loading Google Maps API:', error);
    });
  }
  ngAfterViewInit(): void {
    // Initialize the map after the view is fully initialized
    // this.initMap();
  }
  initMap(): void {
    if (typeof google !== 'undefined' && google.maps) {
      const map = new google.maps.Map(document.getElementById('map') as HTMLElement, {
        center: this.center,
        zoom: this.zoom
      });
      // Optional: Add a marker
      new google.maps.Marker({
        position: this.center,
        map: map,
        title: 'San Francisco'
      });
    } else {
      console.error('Google Maps is not available.');
    }
  }
  getStates = () => {
    this.commonDataService.loaderStatus.next(true);
    this.apiService.getData(Urls.getState).subscribe(
      response => {
        this.stateList = response.data.stateList;
        this.commonDataService.loaderStatus.next(false);
      },
      error => {
        this.commonDataService.loaderStatus.next(false);
      }
    );
  };

  getCity = () => {
    this.subContacts = [];
    this.userData.city = "";
    this.commonDataService.loaderStatus.next(true);
    this.apiService.postData(Urls.getCity, { stateId: this.userData.state }).subscribe(
      response => {
        this.cityList = response.data.cityList;
        this.commonDataService.loaderStatus.next(false);
      },
      error => {
        if (error.status === -1) {
          this.cityList = [];
          if (this.cityList) {
            this.toastr.error(No_branches_are_available_for_Selected_State);
          }
        }
        this.commonDataService.loaderStatus.next(false);
      }
    );
  };

  getContactOffice = () => {
    if (this.userData.city === "") {
      this.subContacts = [];
      this.userData.city = "";
    } else {
      this.apiService.postData(Urls.getContactPerson, { cityId: this.userData.city }).subscribe(
        response => {
          if (response.status === 0) {
            this.subContacts = response.data.acceptanceReturn;
          } else {
            this.resetSubContactData();
            this.toastr.error(No_data_found_for_the_selected_city);
          }
        },
        error => {
          if (error.error.errorMessage === null || error.errorMessage === '') {
            this.toastr.error(Something_went_wrong);
          } else {
            this.toastr.error(error.error.errorMessage);
          }
          this.resetSubContactData();
        }
      )
    }
  };

  public resetSubContactData() {
    this.subContacts = [];
  }

  investOnline = () => {
    this.redirectionService.redirectToInvestorPortal();

    // if (!environment.isDRBuild) {
    //   window.open("https://investonline.itiamc.com/", "_blank");
    // } else {
    //   window.open("https://investonline.itiamc.com/", "_blank"); //DR-inv
    // }
  };

  public getNumber(value: any) {
    return value ? parseFloat(value) : 0;
  }
}

